import React from 'react';
import Text from '../../Text';
import * as Styles from './LabelValueStyles';

export interface ItemInterface {
  readonly label: string;
  readonly value: string;
  readonly disabled?: boolean;
}

interface Props {
  items: ItemInterface[];
}

const LabelValue: React.FC<Props> = ({ items }: Props) => {
  return (
    <Styles.Container>
      {items.map((item: ItemInterface, key: number) => {
        const color = item.disabled ? 'black50' : 'black';
        return (
          <Styles.Row key={item.label + item.value}>
            <Text color={color}>{item.label}</Text>
            <Text color={color}>{item.value}</Text>
          </Styles.Row>
        );
      })}
    </Styles.Container>
  );
};

export default LabelValue;
